<template>
    <a :href="data.DETAIL" class="text-dark" target="_blank" v-if="data.CATEGORY != 'ข่าวสาร/ประกาศอื่น'">
        <div class="px-5 py-3 flex items-center border-b-1 hover:bg-gray-100" :title="data.TITLE">
            <div class="w-[3.5rem] h-10 flex-none image-fit overflow-hidden bg-gray-300 rounded-md">
                <img :src="data.IMAGE_URL" v-if="data.IMAGE_URL">
            </div>
            <div class="ml-4 mr-auto overflow-hidden">
                <div class="font-medium truncate">{{data.TITLE}}</div>
                <div class="text-gray-600 text-xs mt-0.5">
                    {{
                        new Date(data.createdAt).toLocaleDateString("th-TH", {
                            year: "numeric",
                            month: "long",
                            day: "numeric",
                        })
                    }}
            </div>
            </div>
        </div>
    </a>
    <router-link :to="{name: 'news-detail', params: {id: data._id}}" v-else>
        <div class="px-5 py-3 flex items-center border-b-1 hover:bg-gray-100" :title="data.TITLE">
            <div class="w-[3.5rem] h-10 flex-none image-fit overflow-hidden bg-gray-300 rounded-md">
                <img :src="data.IMAGE_URL" v-if="data.IMAGE_URL">
            </div>
            <div class="ml-4 mr-auto overflow-hidden">
                <div class="font-medium truncate">{{data.TITLE}}</div>
                <div class="text-gray-600 text-xs mt-0.5">
                    {{
                        new Date(data.createdAt).toLocaleDateString("th-TH", {
                            year: "numeric",
                            month: "long",
                            day: "numeric",
                        })
                    }}
            </div>
            </div>
        </div>
    </router-link>
</template>

<script>
import { defineComponent } from 'vue'
export default defineComponent({
    props:{
        data: Object,
    }
})
</script>

<style>

</style>